import React from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Fab, Action } from "react-tiny-fab";
import "react-tiny-fab/dist/styles.css";
import AddIcon from "@mui/icons-material/Add";
import CreateIcon from "@mui/icons-material/Create";
import { useTranslation } from "react-i18next";

const FabButton = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.resolvedLanguage;
  const location = useLocation();
  const mainButtonStyles = { backgroundColor: "#1976D2" };
  const history = useHistory();

  function addInvoice() {
    history.push(`/${currentLang}/app/add/invoice`);
  }

  return (
    <div>
      <Fab
        mainButtonStyles={mainButtonStyles}
        icon={<AddIcon />}
        alwaysShowTitle={true}
        style={{ bottom: "60px" }}
      >
        {location.pathname !== `/${currentLang}/app/add/invoice` && (
          <Action text={t("new_invoice")} onClick={addInvoice}>
            <CreateIcon />
          </Action>
        )}
      </Fab>
    </div>
  );
};

export default FabButton;
